import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { ActivatedRoute } from '@angular/router';
import { Utils } from '../../util';

import { LiftOrderService, BasedOn } from '../../services/lift-order.service';
import { ProductClientService } from '../../services/product-client.service';
import { QuotService } from '../../services/quot.service';

import { ISubscription, Subscription } from "rxjs/Subscription";
import { AddressService } from '../../services/address.service';
import { ProductVntaService } from '../../services/product-vnta.service';

@Component({
  selector: 'app-create-lift-order',
  templateUrl: './create-lift-order.component.html',
  styleUrls: ['./create-lift-order.component.css']
})
export class CreateLiftOrderComponent implements OnInit, OnDestroy {
  loading: boolean[] = [false, false, false, false];
  get loaded(): boolean { return !this.loading.includes(false); }

  customerId: string;

  liftOrderForm: FormGroup;

  BasedOn = BasedOn;
  basedOn: BasedOn = BasedOn.PrClient;

  prClients = {};
  selectedPrClientId: string = '';
  prClientSub;
  quots = {};
  selectedQuotId: string = '';
  quotSub;
  addresses = {};
  selectedAddressId: string = '';
  addressSub;
  prVntas = {};
  selectedPrVntaId: string = '';
  prVntaSub;
  
  pickadateParams = Utils.pickadateParams();

  constructor(
    private service: LiftOrderService,
    private prClientService: ProductClientService,
    private quotService: QuotService,
    private addressService: AddressService,
    private prVntaService: ProductVntaService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.customerId = this.activatedRoute.snapshot.paramMap.get('customerId');
    this.prClients = {};
    this.prClientSub = this.prClientService.getPrClients({customerId: this.customerId, onEmpty: () => {
      toast('Advertencia: No hay productos de este cliente.', 3000);
      this.loading[0] = true;
    } }).subscribe(prClients => {
      this.prClientSub.unsubscribe();
      this.rowsRead[0] = prClients.map(prClient => {
        this.prClients[prClient.id] = {...prClient};
        this.prClients[prClient.prVntaObj.name] = {...prClient};
        prClient.customerName = prClient.customerObj.name;
        prClient.employeeName = `${prClient.employeeObj.name.trim()} ${prClient.employeeObj.lastName.trim()}`;
        prClient.name = prClient.prVntaObj.name;
        return prClient;
      });
      this.loading[0] = true;
    });
    this.quots = {};
    this.quotSub = this.quotService.getQuots({onEmpty: ()=>{ this.loading[1] = true } }).subscribe(quots => {
      this.quotSub.unsubscribe();
      this.rowsRead[1] = quots.filter(quot => {
        this.quots[quot.id] = {...quot};
        this.quots[quot.folio] = {...quot};
        quot.name = quot.folio;
				if(quot.customerObj.id == this.customerId) return quot;
      });
      this.loading[1] = true;
    });
    this.addresses = {};
    this.addressSub = this.addressService.getCustomerAddresses(this.customerId, {onEmpty: ()=>{ this.loading[2] = true } }).subscribe(addresses => {
      this.addressSub.unsubscribe();
      this.rowsRead[2] = addresses.filter(address => {
        address.name = `${address.street}, #${address.externalNumber}`;
        this.addresses[address.id] = {...address};
        return address;
      });
      this.loading[2] = true;
    });
    this.prVntas = {};
    this.prVntaSub = this.prVntaService.getPrVntas({onEmpty: () => {
      toast('Advertencia: No hay productos de venta.', 3000);
      this.loading[3] = true;
    } }).subscribe(prVntas => {
      this.prVntaSub.unsubscribe();
      this.rowsRead[3] = prVntas.map(prVnta => {
        this.prVntas[prVnta.id] = prVnta;
        prVnta.class = prVnta.data.name;
        return prVnta;
      });
      this.loading[3] = true;
    });
  }

  ngOnInit() {
    this.createForm();
  }
	ngOnDestroy() {
  }

  createForm(){
    this.liftOrderForm = this.fb.group({
      date: [this.today, Validators.required],
      deliveryDate: [this.today, Validators.required],
      number: ['', Validators.required],
      quantity: ['', [Validators.required, Validators.min(0)]],
      pricePerUnit: ['', [Validators.required, Validators.min(0)]]
    });
  }

  onSubmit({ value, valid }: { value: any, valid: any }){

    value.customerRef = this.customerId;
    value.prClientRef = this.selectedPrClientId;
    value.quotRef = this.selectedQuotId;
    value.addressId = this.selectedAddressId;
    value.prVntaRef = this.selectedPrVntaId;
    value.status = 0;
    value.basedOn = this.basedOn;

    this.service.addLiftOrder(value);
    this.service.windowReplace('read');
  }

  onPpuChange(){
    let input = this.liftOrderForm.get('pricePerUnit');
    input.patchValue(+input.value.toFixed(4))
  }

  openModalRead(index: number) {
    this.currentReadIndex = index;
    this.data = this.rowsRead[index];
    
    this.config = this.configs[index];
  
    this.onChangeTable(this.config);
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead(data: any): any{
    if(this.currentReadIndex == 0){
      this.selectedPrClientId = data.row.id;
      this.selectedPrVntaId = data.row.prVntaId;
      this.liftOrderForm.get('pricePerUnit').patchValue(+data.row.agreedPrice || 0);
    }
    if(this.currentReadIndex == 1){
      this.selectedQuotId = data.row.id;
      this.selectedPrVntaId = data.row.prVntaRef.id;
      const quotRow = this.quots[this.selectedQuotId].finalTableRows[0].row;
      this.liftOrderForm.get('pricePerUnit').patchValue(+quotRow[quotRow.length-3].toFixed(2));
    };
    if(this.currentReadIndex == 2) this.selectedAddressId = data.row.id;
    if(this.currentReadIndex == 3) this.selectedPrVntaId = data.row.id;
    this.closeModalRead();
  }

  get today(){
    var today = new Date();
    var dd:string = today.getDate() + '';
    var mm:string = today.getMonth()+ 1 + '';
    var yyyy = today.getFullYear();
    if(+dd<10) dd = '0'+dd;
    if(+mm<10) mm = '0'+mm;
    return yyyy + '-' + mm + '-' + dd;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 

  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  
  get readValid(){ return (
    this.basedOn == BasedOn.PrClient && this.selectedPrClientId ||
    this.basedOn == BasedOn.PrVnta && this.selectedPrVntaId ||
    this.basedOn == BasedOn.Quot && this.selectedQuotId
  )};
  currentReadIndex: number;
  rowsRead = [[],[],[],[]];
  columnsRead = [
    [//prClient
      {title: 'Producto' , name: 'name',sort: 'asc'},
      {title: 'Clave Prod' , name: 'code'},
      {title: 'Versión' , name: 'version'},
      {title: 'Cliente', name: 'customerName'},
      {title: 'Ejecutivo a cargo', name: 'employeeName'}
    ],
    [//quot
      { title: 'Folio', name: 'name', sort: 'asc' },
      { title: 'Fecha', name: 'date' },
      { title: 'Estado', name: 'status' }
    ],
    [//address
      { title: 'Dirección', name: 'name', sort: 'asc' },
      { title: 'C.P.', name: 'zipCode' },
      { title: 'Municipio', name: 'municipality' }
    ],
    [//prVnta
      {title: 'Nombre', name: 'name',sort: 'asc'},
      {title: 'Descripción', name: 'description'},
      {title: 'Clasificación' , name: 'class'},
      {title: 'Código', name: 'code'},
    ]
  ]


  data:Array<any>;
  rows:Array<any> = [];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config;
  configs:any = this.columnsRead.map(columns => ({
    paging: true,
    sorting: {columns: columns},
    filtering: {filterString: ''}
  }));

  /*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columnsRead[this.currentReadIndex].forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columnsRead[this.currentReadIndex].forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA

}
